<template>
  <div v-rect-loading="loading" class="account-container">
    <div class="account-editor-header">
      <div class="account-editor-title">{{ $t(`${i18nPrefix}.title.accountCancellation`) }}</div>
    </div>
    <div class="account-info-container">
      <WrappedFrom
        ref="form"
        class="account-info"
        label-width="220px"
        :model="accountInfo"
        :formLines="formLines"
      ></WrappedFrom>
      <div class="bottom-btn-group">
        <el-button class="save-btn" type="primary" @click="handleSave">{{ $t(`${i18nPrefix}.label.cancellation`) }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import WrappedFrom from '@/components/formEditor/wrappedForm.vue'

export default {
  components: {
    WrappedFrom
  },
  data () {
    return {
      i18nPrefix: 'admin.company.userManagement',
      loading: false,
      accountInfo: {
        emailAddressOrMobile: null,
        newEmailAddress: null,
        disable: false,
        unbindWeChat: false,
        revokeAllApplication: false
      }
    }
  },
  computed: {
    formLines () {
      const lines = {
        emailAddressOrMobile: {
          label: this.$t(`${this.i18nPrefix}.label.emailOrMobile`),
          placeholder: this.$t(`${this.i18nPrefix}.label.emailOrMobile`),
          rules: [{ required: true, message: this.$t('common.message.requiredFormField'), trigger: 'blur' }],
          events: { blur: this.handleEmailOrMobile }
        },
        newEmailAddress: {
          label: this.$t(`${this.i18nPrefix}.label.emailAfterCancellation`),
          rules: [{ required: true, message: this.$t('common.message.requiredFormField'), trigger: 'blur' }],
          props: { type: 'email' },
          class: 'new-email-address'
        },
        disable: {
          elType: 'el-checkbox',
          checkboxLabel: this.$t(`${this.i18nPrefix}.label.disableAccount`),
          class: 'disable-email-address'
        },
        unbindWeChat: {
          elType: 'el-checkbox',
          checkboxLabel: this.$t(`${this.i18nPrefix}.label.unbindWeChat`),
          class: 'un-bind-wechat'
        },
        revokeAllApplication: {
          elType: 'el-checkbox',
          checkboxLabel: this.$t('admin.application.candidate.btn.revokeAllApplication')
        }
      }

      return lines
    }
  },
  created () {
  },
  methods: {
    ...mapActions('userManagement', ['getCancellationAccountByEmailOrMobile', 'deleteAccount']),
    async handleSave () {
      const result = await this.$refs.form.submit()
      if (!result) {
        return
      }

      this.loading = true
      try {
        const { emailAddressOrMobile, newEmailAddress, disable, unbindWeChat, revokeAllApplication } = this.accountInfo
        const params = {
          email_address_or_mobile: emailAddressOrMobile,
          new_email_address: newEmailAddress,
          disable,
          unbind_we_chat: unbindWeChat,
          revoke_all_application: revokeAllApplication
        }
        await this.deleteAccount(params)
        this.$message({
          type: 'success',
          message: this.$t(`${this.i18nPrefix}.message.cancellationSuccess`)
        })
        this.accountInfo = {
          emailAddressOrMobile: null,
          newEmailAddress: null,
          disable: false,
          unbindWeChat: false,
          revokeAllApplication: false
        }
      } finally {
        this.loading = false
      }
    },
    async handleEmailOrMobile () {
      if (!this.accountInfo.emailAddressOrMobile) {
        return
      }
      const params = {
        email_address_or_mobile: this.accountInfo.emailAddressOrMobile
      }
      const resp = await this.getCancellationAccountByEmailOrMobile(params)
      if (resp) {
        this.accountInfo.newEmailAddress = resp.new_email_address
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.account-container {
  .account-editor-header {
    display: flex;
    border-bottom: 1px solid #e4e7ed;
    .account-editor-title {
      padding-top: 4px;
      padding-bottom: 18px;
      line-height: 25px;
      font-size: 18px;
      font-weight: 500;
      color: #303133;
    }
  }
  .account-info-container {
    width: 620px;
    margin: 30px auto 0;

    ::v-deep {
      .new-email-address {
        margin-bottom: 10px;
      }

      .disable-email-address {
        margin-bottom: 0px;
      }

      .un-bind-wechat {
        margin-bottom: 0px;
      }
    }

    .bottom-btn-group {
      display: flex;
      justify-content: flex-end;
      margin: 20px auto 0;
      .el-button {
        padding: 8px 28px;
        border-radius: 2px;
        line-height: 22px;
        font-size: 16px;
        font-weight: 500;
        color: #0096cc;

        &:last-child {
          margin-left: 20px;
          margin-right: 0;
          background: #0096cc;
          border-color: #0096cc;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
